const en = {
  "about_us": '',
  "activities": "activities",
  "adult": "Adult",
  "adults": "Adults",
  "age": "Age",
  "all": "All",
  "app_name": "Gausta",
  "appInfo": "Download the Gausta app – your guide to Gausta",
  "articles": "Articles",
  "bottom_collection_about": 'About gausta',
  "bottom_collection_opening_hours": 'Opening hours',
  "bottom_collection_cabins": 'Cabins for sale',
  "bottom_collection_contact": 'Contact info & opening hours',
  "bottom_collection_news": 'News',
  "bottom_collection_work": 'Work at gausta',
  "title_service": '',
  "breadcrumb_prefix": "You are here:",
  "cabins_and_apartments": "Cabins and apartments",
  "call": "Phone number",
  "center_collection1_accomodation": 'Accommodation',
  "center_collection1_here": 'Get here',
  "center_collection1_maps": 'Maps',
  "center_collection1_offers": 'Offers and campaigns',
  "center_collection1_packages": 'Packages',
  "center_collection1_service": 'Services',
  "center_collection1_app": 'Gausta app',
  "center_collection1_transport": 'Transport',
  "center_collection1_title": 'Plan your trip',
  "center_collection1_webcams": 'Webcams',
  "center_collection2_calendar": 'Event calendar',
  "center_collection2_food": 'Food and drink',
  "center_collection2_gaustabanen": 'Gaustabanen',
  "center_collection2_gaustaoppen": 'Gaustatoppen',
  "center_collection2_see": 'See and do',
  "center_collection2_health": 'Health and wellness',
  "center_collection2_skisenter": 'Gausta skisenter',
  "center_collection2_title": 'Experience Gausta',
  "center_collection2_travel": 'Travel guides',
  "center_collection3_courses": 'Experiences and courses',
  "center_collection3_rental": 'Ski rental',
  "center_collection3_school": 'Ski school and private lessons',
  "center_collection3_ski": 'Ski pass',
  "center_collection3_season": 'Season pass',
  "center_collection3_title": 'Buy/Book',
  "center_collection3_meeting": 'Meeting and conference',
  "center_collection4_title": 'ABOUT GAUSTA',
  "bottom_collection_renting_cabin": "Renting out your cabin?",
  "check_in": "Arrival",
  "check_out": "Departure",
  "child": "Child",
  "children": "Children",
  "childrens_age": "The age of the children",
  "closed": "Closed",
  "coming_days_prognosis": "Coming days prognosis",
  "contact_information": "Contact information",
  "customer_service_collection_contact": 'Contact info and opening hours',
  "customer_service_collection_faq": 'FAQ',
  "customer_service_collection_save": 'Safe and sound',
  "customer_service_collection_terms": 'Terms and conditions',
  "eat_and_drink": "Eat & Drink",
  "email_placeholder": "Enter your e-mail",
  "error_404": "Page not found",
  "events_choose_dates": "Choose start/end dates",
  "events_upcoming_dates": "Upcoming dates",
  "events": "Events",
  "facebook_read_more": "Read more on Facebook",
  "filter": "Filter",
  "fnugg_cross_country": "Crosscountry",
  "fnugg_menu_cloud": "Cloudy",
  "fnugg_menu_fog": "Fog",
  "fnugg_menu_gausta_today": "Gausta today",
  "fnugg_menu_header": "Weather and Operating status",
  "fnugg_menu_puder_alert": "Puder alert!",
  "fnugg_menu_rain": "Rain",
  "fnugg_menu_snow": "Snow",
  "fnugg_menu_storm": "Storm",
  "fnugg_menu_sun": "Sunny",
  "fnugg_menu_wind": "Wind",
  "fnugg_operation_status": "Operation status",
  "fnugg_report_coming_days": "Coming days prognosis",
  "fnugg_report_last_day": "Last day",
  "fnugg_report_last_week": "Last week",
  "fnugg_report_terreng": "Terreng",
  "fnugg_report_weather_today": "Weather today",
  "fnugg_snow_depth": "Snow depth",
  "fnugg_temp": "Temperature",
  "footer_collection_about": "About Gausta",
  "footer_collection_cabins_rent": "Renting out your cabin?",
  "footer_collection_cabins_sale": "Cabins for sale",
  "footer_collection_career": "Work at Gausta",
  "footer_collection_news": "News",
  "footer_email_subscribe": "",
  "footerText": "Gausta.com is the official booking centre for Gausta. Here you’ll find the best selection of lodging in the Gausta area, ski passes to Gausta Skisenter, and a wide selection of activities and exclusive package deals.",
  "from_13_years": "From 13 years",
  "from": "From",
  "guests": "Guests",
  "hotel": "Hotell",
  "last_day": "Last day",
  "last_updated": "Latest update",
  "last_week": "Last week",
  "lifts": "Lifts",
  "mail": "E-mail",
  "map_temp": "Temp",
  "map_wind": "Wind",
  "maps_cross": "Cross-country trails",
  "maps_summer": "Summer map",
  "maps_winter": "Ski map",
  "menu": "Menu",
  "my_pages": "My pages",
  "on_this_page": "On this page",
  "only_lights": "Nightly open slopes",
  "only_open": "Only open",
  "open": "Open",
  "opened": "Opened",
  "other": "Other",
  "overview": "Overview",
  "packages": "Packages",
  "phone_number": "Phone number",
  "policy": "Privacy Policy",
  "read_more": "Read more",
  "results": "results",
  "search_and_book": "Search and Book",
  "search_placeholder": "Search in Gausta.com",
  "search": "Search",
  "searchwidget_activities": "Our activities",
  "searchwidget_adults_age": "From 13 years",
  "searchwidget_adults": "Adults",
  "searchwidget_age": "Age",
  "searchwidget_arrival": "Arrival",
  "searchwidget_cabins": "Cabins and apartments",
  "searchwidget_child": "Child",
  "searchwidget_children_age": "Ages 0-12",
  "searchwidget_children": "Children",
  "searchwidget_departure": "Departure",
  "searchwidget_guests": "Guests",
  "searchwidget_hotel": "Hotel",
  "searchwidget_label_from": "From",
  "searchwidget_label_to": "To",
  "searchwidget_picker_title": "The age of the children",
  "searchwidget_skisenter_item": "Ski pass",
  "searchwidget_skisenter_item2": "Ski school",
  "searchwidget_skisenter_item3": "Private lessons",
  "searchwidget_skisenter_item4": "Experiences and courses",
  "searchwidget_skisenter_item5": "Ski rental",
  "searchwidget_skisenter": "Gausta Skisenter",
  "searchwidgetmobile_title": "Book",
  "skicenter": "Gausta Skisenter",
  "slopes": "Slopes",
  "snow_depth": "Snow depth",
  "soMeText": "Stay up to date",
  "subscribe": "Subscribe",
  "terrain": "Terrain",
  "to_12_years": "Ages 0-12",
  "to": "To",
  "top_collection_accomodation": 'Accommodation',
  "top_collection_food": 'Food and drink',
  "top_collection_gaustabanen": 'Gaustabanen',
  "top_collection_packages": 'Packages',
  "top_collection_see": 'See and do',
  "top_collection_skisenter": 'Gausta skisenter',
  "topNotificationLink": "Renovering av hotellrom",
  "topNotificationMessage": "In the period from 28 September to 18 December, Gaustablikk Fjellresort will renovate 60 rooms. ",
  "topRedBar_button": "Read more",
  "topRedBar_message": "We are currently updating our booking system to provide you with a better experience. While this is happening, you may experience some small errors. If there  is anything that we can help you with, you can get in touch with us at",
  "topRedBar_message2": "or",
  "topRedBar_message3": " ",
  "topRedBar_phone": "004735091422",
  "upcoming": "Upcoming",
  "view_only": "VIEW ONLY",
  "visit": "Visit",
  "weather_today": "Weather today",
  "weather": "Weather",
  "webcams": "Webcams",
  "website": "Website",
  "widget_book_at_gausta": "Book",
  "wind": "Wind",
  "newpassword": "Create a new password",
  "resetPassword": "Your new password is now saved!",
  "buttonContinueText": "Continue",
  "newPasswordDescription": "Reset your password",
  "newPasswordDescription2": "To reset your password, please enter your email:",
  "temporaryPasswordDescription": "A temporary password has been sent to you at the following address:",
  "temporaryPasswordDescription2": "If this mail account is registered, you will see the temporary password on your inbox. Please enter it below:",
  "temporaryPasswordLabel": "Temporary password",
  "belowPassword": "You can customize the new password below:Below you can enter a password of your choice:",
  "newPasswordLabel": "New password",
  "repeatPasswordLabel": "Repeat new password",
  "email": "E-mail",
  "login": "Log in",
  "password": "Password",
  "forgotPassword": "Forgot password?",
  "accountNotFound": "Sorry, but this email address does not appear to be linked to any user account.",
  "wrongPassword": "Sorry, but the password does not appear to be correct",
  "unexpectedError": "Unexpected error",
  "link_accomodation": "/en-US/accommodation",
  "link_packages": "/en-US/packages",
  "link_food_and_drink": "/en-US/food-and-drink",
  "link_see_and_do": "/en-US/see-and-do",
  "link_health_and_wellness": "/en-US/treatments",
  "link_gausta_skisenter": "/en-US/gausta-skisenter",
  "link_gaustabanen": "/en-US/gaustabanen",
  "link_offers": "/en-US/offers-and-campaigns",
  "link_services": "/en-US/services",
  "link_app": "/en-US/gausta-app",
  "link_transport": "/en-US/bus/",
  "link_get_here": "/en-US/how-to-get-here",
  "link_webcams": "/en-US/webcam",
  "link_maps": "/en-US/maps",
  "link_event_calendar": "/en-US/event-calendar",
  "link_travel_guides": "/en-US/travel-guides",
  "link_gaustaoppen": "/en-US/gaustatoppen",
  "link_ski_pass": "/en-US/ski-pass",
  "link_season_pass": "/en-US/season-pass",
  "link_ski_school": "/en-US/ski-school",
  "link_ski_rental": "/en-US/gausta-ski-rental",
  "link_meeting": "/en-US/conference",
  "link_experiences_and_courses": "/en-US/ski-experiences-and-courses",
  "link_contact": "/en-US/contact-us/",
  "link_opening_hours": "/en-US/opening-hours",
  "link_about_gausta": "/en-US/about-gausta",
  "link_work_at_gausta": "/en-US/work-at-gausta",
  "link_news": "/en-US/news",
  "link_cabins_for_sale": "/en-US/cabins-for-sale",
  "link_cabins_rent": "/en-US/renting-out-your-cabin",
  "link_contact_us": "/en-US/contact-us",
  "link_faq": "/en-US/faq",
  "link_safe_and_sounds": "/en-US/safe-and-sound",
  "link_terms_and_conditions": "/en-US/terms-and-conditions",
  "link_cart": "/en-US/shopping-cart",
  "link_home": "/en-US",
  "link_sesongkort": "/en-US/gausta-skisenter",
  "link_heiskort": "/en-US/ski-pass",
  "link_search": "/en-US/search",
  "link_searchbutton_hotel": "https://book.gausta.com/en/stays/hotel/1967823?category=35937",
  "link_searchbutton_cabinsAndApartments":"https://book.gausta.com/en/stays?category=35936",
  "link_searchbutton_aktiviteter":"https://book.gausta.com/en/book/todo?filter=c=42324;g=108345&sorting=st=a;so=a",
  "link_privacy_policy": "/en-US/privacy-policy/",
  "link_hotel_mobile": "https://book.gausta.com/en/stays?category=35937",
  "link_cabins_mobile": "https://book.gausta.com/en/stays?category=35936",
  "link_aktiviter_mobile": "https://book.gausta.com/en/book/todo?filter=c=42324;g=108345;sorting=st=a;so=a",
  "external_link_ski_school": "https://book.gausta.com/en/ski-school",
  "link_ski_private_lessons": "https://book.gausta.com/en/private-lessons",
  "link_experiences": "https://book.gausta.com/en/experiences",
  "external_link_ski_rental": "https://book.gausta.com/en/ski-rental",
  "link_renting_cabin": "/en-US/renting-out-your-cabin",
  "season_pass_label": 'Season Pass',
  "lodging_label": 'Lodging & Skipasses',
  "lodging": "lodging",
  "footer_skisenter": "/en-US/gausta-skisenter/",
  "footer_skiskole": "/en-US/ski-school/",
  "footer_aktivitetssenter": "/en-US/see-and-do/",
  "footer_dagligvare": "/en-US/pose-og-sekk-dagligvare/",
  "footer_bakeriet": "/en-US/bakeriet/",
  "footer_gaustabanen": "/en-US/gaustabanen/",
  "footer_rjukan": "https://www.visitrjukan.com/",
  "footer_stova": "/en-US/gausta-stova",
  "footer_loftet": "/en-US/event-calendar/afterski/",
  "continueButton": "Continue without login"
}

export default en;
